import TestimonialsActionCard from "../_local/components/NewCards/TestimonialsActionCard";
import React from "react";
// Adjust the path if necessary

interface Testimonial {
    TESTIMONIALS_IMAGE?: { selectedImage: string };
    TESTIMONIALS_NAME?: string;
    TESTIMONIALS_TESTIMONIAL?: string;
    TESTIMONIALS_DESIGNATION?: string;
    // Add other properties of your testimonial object if needed
}

const TestimonialPreview = () => {
    const testimonialsData: Testimonial[] = JSON.parse(sessionStorage.getItem("testimonials")) || [];

    if (!testimonialsData || testimonialsData.length === 0) {
        return <p className="text-gray-500">No testimonials added yet.</p>;
    }

    return (
        <div className="grid grid-cols-4 gap-4 sm:grid-cols-1 md:grid-cols-1">
            {testimonialsData.map((testimonial, index) => (
                <TestimonialsActionCard
                    key={`testimonial-preview-${index}`}
                    element={testimonial}
                    // handleOpenDrawer={() => {}} // No operation function for preview
                    // onDelete={() => {}} // No operation function for preview
                    isError={false} // No error indication in preview
                />
            ))}
        </div>
    );
};

export default TestimonialPreview;